<template>
  <div>
    <div v-if="!hasCloudFrontAliasBeenQueried">
      <mia-button
        class="inline-flex items-center px-3 py-2 ml-2 text-gray-700 border-2 rounded-sm border-orange-mia focus:outline-none"
        :class="{
          'is-loading': $wait.is(loaderName),
          'hover:bg-orange-mia hover:text-white': !$wait.is(loaderName)
        }"
        :disabled="$wait.is(loaderName)"
        title="CloudFront Alias für diese Domain abfragen"
        @click.native="queryCloudFrontAliasStatus"
      >
        <template v-if="$wait.is(loaderName)">
          <mia-wave-loader size="small" />

          <span class="ml-2">
            wird abgefragt…
          </span>
        </template>
        <template v-else>
          <svg
            width="20"
            height="24"
            preserveAspectRatio="xMidYMid"
            viewBox="0 0 256 310"
          >
            <path
              d="M73.871 282.05l54.097 27.051 5.284-3.942-2.224-301.561L127.968 0 73.871 27.051V282.05"
              fill="#9D5025"
            />
            <path
              d="M182.065 282.05l-54.097 27.051V0l54.097 27.051V282.05"
              fill="#F68536"
            />
            <path
              d="M107.571 112.513l-18.984 2.764L0 105.296l.375-.983L14.75 100l1.529.866.346-.866L107 110.563l.571 1.95"
              fill="#6B3A19"
            />
            <path
              d="M0 63.988l16.279-8.144v45.022L0 105.296V63.988"
              fill="#9D5025"
            />
            <path
              d="M256 131.063l-90.661 4.869-16.975-1.164 3.198-1.33 88.375-5.063L256 131.063"
              fill="#6B3A19"
            />
            <path
              d="M107.571 112.513l-91.292-11.647V55.844l91.292 21.414v35.255"
              fill="#F68536"
            />
            <path
              d="M239.656 82.225l-91.292 15.691v36.852l91.292-5.478.531-1.04L240 83.063l-.344-.838"
              fill="#9D5025"
            />
            <path
              d="M256 131.063l-16.344-2.125V82.225L256 88.21v42.853"
              fill="#F68536"
            />
          </svg>

          <span class="mx-2">+</span>

          <svg
            width="20"
            height="24"
            preserveAspectRatio="xMidYMid"
            viewBox="0 0 256 308"
          >
            <path
              d="M166.01 127.465l59.202-6.314 30.676 6.369.111.068-56.558 3.374-33.484-3.442.053-.055z"
              fill="#5E1F18"
            />
            <path
              d="M165.958 127.521l59.204-4.625.407-.593.002-73.044-.407-.835-59.206 15.397v63.7"
              fill="#8C3123"
            />
            <path
              d="M256 127.59l-30.838-4.694.002-74.472 30.835 15.428.001 63.738"
              fill="#E05243"
            />
            <path
              d="M165.958 180.115l.865.606 58.349 3.959 29.772-3.959 1.055-.579-56.557-3.475-33.484 3.448"
              fill="#F2B0A9"
            />
            <path
              d="M165.958 180.115l59.214 4.405.183.246-.045 73.942-.146.386-59.206-15.275v-63.704"
              fill="#8C3123"
            />
            <path
              d="M255.999 180.142l-30.827 4.378-.008 74.574 30.835-15.309v-63.643"
              fill="#E05243"
            />
            <g>
              <path
                d="M89.119 127.408l-58.53-5.014L.195 127.44l-.193.151 56.557 3.374 32.874-3.376-.314-.18z"
                fill="#5E1F18"
              />
              <path
                d="M.002 127.59l30.557-4.474.899-.637v-73.2l-.899-.855L.002 63.855v63.735"
                fill="#8C3123"
              />
              <path
                d="M89.433 127.588l-58.874-4.472V48.424l58.877 15.397-.003 63.767"
                fill="#E05243"
              />
            </g>
            <g>
              <path
                d="M89.433 180.142l-1.351.985-57.523 4.313-29.583-4.313-.976-.985 56.559-3.475 32.874 3.475"
                fill="#F2B0A9"
              />
              <path
                d="M0 180.142l30.558 4.34.777.952.083 72.333-.859 1.327L.002 243.785 0 180.142"
                fill="#8C3123"
              />
              <path
                d="M89.433 180.142l-58.875 4.34.001 74.612 58.874-15.275v-63.677"
                fill="#E05243"
              />
            </g>
            <g>
              <path
                d="M189.104 189.66l-61.103-6.026-61.712 6.027.87.735 60.541 9.617 60.533-9.617.871-.736"
                fill="#F2B0A9"
              />
              <path
                d="M66.289 189.661l61.411 8.998.623.833.079 106.959-.702 1.186-61.411-30.706v-87.27"
                fill="#8C3123"
              />
              <path
                d="M189.104 189.66l-61.404 8.999v108.978l61.405-30.706-.001-87.271"
                fill="#E05243"
              />
            </g>
            <g>
              <path
                d="M128.001 123.933l-61.712-5.958.159-.091 61.249-9.502 61.222 9.524.186.069-61.104 5.958z"
                fill="#5E1F18"
              />
              <path
                d="M66.289 117.975l61.411-8.949.294-.268L127.858.165 127.7 0 66.289 30.709v87.266"
                fill="#8C3123"
              />
              <path
                d="M189.105 117.975l-61.405-8.949V0l61.405 30.709v87.266"
                fill="#E05243"
              />
            </g>
          </svg>

          <span class="ml-2">= ?</span>
        </template>
      </mia-button>
    </div>
    <div
      v-else-if="hasCloudFrontAlias"
      class="flex items-center"
    >
      <svg
        width="20"
        height="24"
        preserveAspectRatio="xMidYMid"
        viewBox="0 0 256 310"
      >
        <path
          d="M73.871 282.05l54.097 27.051 5.284-3.942-2.224-301.561L127.968 0 73.871 27.051V282.05"
          fill="#9D5025"
        />
        <path
          d="M182.065 282.05l-54.097 27.051V0l54.097 27.051V282.05"
          fill="#F68536"
        />
        <path
          d="M107.571 112.513l-18.984 2.764L0 105.296l.375-.983L14.75 100l1.529.866.346-.866L107 110.563l.571 1.95"
          fill="#6B3A19"
        />
        <path
          d="M0 63.988l16.279-8.144v45.022L0 105.296V63.988"
          fill="#9D5025"
        />
        <path
          d="M256 131.063l-90.661 4.869-16.975-1.164 3.198-1.33 88.375-5.063L256 131.063"
          fill="#6B3A19"
        />
        <path
          d="M107.571 112.513l-91.292-11.647V55.844l91.292 21.414v35.255"
          fill="#F68536"
        />
        <path
          d="M239.656 82.225l-91.292 15.691v36.852l91.292-5.478.531-1.04L240 83.063l-.344-.838"
          fill="#9D5025"
        />
        <path
          d="M256 131.063l-16.344-2.125V82.225L256 88.21v42.853"
          fill="#F68536"
        />
      </svg>

      <span class="mx-2">+</span>

      <svg
        width="20"
        height="24"
        preserveAspectRatio="xMidYMid"
        viewBox="0 0 256 308"
      >
        <path
          d="M166.01 127.465l59.202-6.314 30.676 6.369.111.068-56.558 3.374-33.484-3.442.053-.055z"
          fill="#5E1F18"
        />
        <path
          d="M165.958 127.521l59.204-4.625.407-.593.002-73.044-.407-.835-59.206 15.397v63.7"
          fill="#8C3123"
        />
        <path
          d="M256 127.59l-30.838-4.694.002-74.472 30.835 15.428.001 63.738"
          fill="#E05243"
        />
        <path
          d="M165.958 180.115l.865.606 58.349 3.959 29.772-3.959 1.055-.579-56.557-3.475-33.484 3.448"
          fill="#F2B0A9"
        />
        <path
          d="M165.958 180.115l59.214 4.405.183.246-.045 73.942-.146.386-59.206-15.275v-63.704"
          fill="#8C3123"
        />
        <path
          d="M255.999 180.142l-30.827 4.378-.008 74.574 30.835-15.309v-63.643"
          fill="#E05243"
        />
        <g>
          <path
            d="M89.119 127.408l-58.53-5.014L.195 127.44l-.193.151 56.557 3.374 32.874-3.376-.314-.18z"
            fill="#5E1F18"
          />
          <path
            d="M.002 127.59l30.557-4.474.899-.637v-73.2l-.899-.855L.002 63.855v63.735"
            fill="#8C3123"
          />
          <path
            d="M89.433 127.588l-58.874-4.472V48.424l58.877 15.397-.003 63.767"
            fill="#E05243"
          />
        </g>
        <g>
          <path
            d="M89.433 180.142l-1.351.985-57.523 4.313-29.583-4.313-.976-.985 56.559-3.475 32.874 3.475"
            fill="#F2B0A9"
          />
          <path
            d="M0 180.142l30.558 4.34.777.952.083 72.333-.859 1.327L.002 243.785 0 180.142"
            fill="#8C3123"
          />
          <path
            d="M89.433 180.142l-58.875 4.34.001 74.612 58.874-15.275v-63.677"
            fill="#E05243"
          />
        </g>
        <g>
          <path
            d="M189.104 189.66l-61.103-6.026-61.712 6.027.87.735 60.541 9.617 60.533-9.617.871-.736"
            fill="#F2B0A9"
          />
          <path
            d="M66.289 189.661l61.411 8.998.623.833.079 106.959-.702 1.186-61.411-30.706v-87.27"
            fill="#8C3123"
          />
          <path
            d="M189.104 189.66l-61.404 8.999v108.978l61.405-30.706-.001-87.271"
            fill="#E05243"
          />
        </g>
        <g>
          <path
            d="M128.001 123.933l-61.712-5.958.159-.091 61.249-9.502 61.222 9.524.186.069-61.104 5.958z"
            fill="#5E1F18"
          />
          <path
            d="M66.289 117.975l61.411-8.949.294-.268L127.858.165 127.7 0 66.289 30.709v87.266"
            fill="#8C3123"
          />
          <path
            d="M189.105 117.975l-61.405-8.949V0l61.405 30.709v87.266"
            fill="#E05243"
          />
        </g>
      </svg>

      <mia-streamline-icon
        class="w-5 h-5 ml-2 text-green-500 fill-current"
        src="check-double"
      />
    </div>
    <mia-button
      v-else
      class="inline-flex items-center px-3 py-2 ml-2 text-gray-700 border-2 rounded-sm border-orange-mia focus:outline-none"
      :class="{
        'is-loading': $wait.is(loaderName),
        'hover:bg-orange-mia hover:text-white': !$wait.is(loaderName)
      }"
      :disabled="$wait.is(loaderName)"
      title="CloudFront Distribution für diese Domain anlegen"
      @click.native="createCloudFrontAlias"
    >
      <template v-if="$wait.is(loaderName)">
        <mia-wave-loader size="small" />

        <span class="ml-2">
          wird erstellt…
        </span>
      </template>
      <template v-else>
        <svg
          width="20"
          height="24"
          preserveAspectRatio="xMidYMid"
          viewBox="0 0 256 308"
        >
          <path
            d="M166.01 127.465l59.202-6.314 30.676 6.369.111.068-56.558 3.374-33.484-3.442.053-.055z"
            fill="#5E1F18"
          />
          <path
            d="M165.958 127.521l59.204-4.625.407-.593.002-73.044-.407-.835-59.206 15.397v63.7"
            fill="#8C3123"
          />
          <path
            d="M256 127.59l-30.838-4.694.002-74.472 30.835 15.428.001 63.738"
            fill="#E05243"
          />
          <path
            d="M165.958 180.115l.865.606 58.349 3.959 29.772-3.959 1.055-.579-56.557-3.475-33.484 3.448"
            fill="#F2B0A9"
          />
          <path
            d="M165.958 180.115l59.214 4.405.183.246-.045 73.942-.146.386-59.206-15.275v-63.704"
            fill="#8C3123"
          />
          <path
            d="M255.999 180.142l-30.827 4.378-.008 74.574 30.835-15.309v-63.643"
            fill="#E05243"
          />
          <g>
            <path
              d="M89.119 127.408l-58.53-5.014L.195 127.44l-.193.151 56.557 3.374 32.874-3.376-.314-.18z"
              fill="#5E1F18"
            />
            <path
              d="M.002 127.59l30.557-4.474.899-.637v-73.2l-.899-.855L.002 63.855v63.735"
              fill="#8C3123"
            />
            <path
              d="M89.433 127.588l-58.874-4.472V48.424l58.877 15.397-.003 63.767"
              fill="#E05243"
            />
          </g>
          <g>
            <path
              d="M89.433 180.142l-1.351.985-57.523 4.313-29.583-4.313-.976-.985 56.559-3.475 32.874 3.475"
              fill="#F2B0A9"
            />
            <path
              d="M0 180.142l30.558 4.34.777.952.083 72.333-.859 1.327L.002 243.785 0 180.142"
              fill="#8C3123"
            />
            <path
              d="M89.433 180.142l-58.875 4.34.001 74.612 58.874-15.275v-63.677"
              fill="#E05243"
            />
          </g>
          <g>
            <path
              d="M189.104 189.66l-61.103-6.026-61.712 6.027.87.735 60.541 9.617 60.533-9.617.871-.736"
              fill="#F2B0A9"
            />
            <path
              d="M66.289 189.661l61.411 8.998.623.833.079 106.959-.702 1.186-61.411-30.706v-87.27"
              fill="#8C3123"
            />
            <path
              d="M189.104 189.66l-61.404 8.999v108.978l61.405-30.706-.001-87.271"
              fill="#E05243"
            />
          </g>
          <g>
            <path
              d="M128.001 123.933l-61.712-5.958.159-.091 61.249-9.502 61.222 9.524.186.069-61.104 5.958z"
              fill="#5E1F18"
            />
            <path
              d="M66.289 117.975l61.411-8.949.294-.268L127.858.165 127.7 0 66.289 30.709v87.266"
              fill="#8C3123"
            />
            <path
              d="M189.105 117.975l-61.405-8.949V0l61.405 30.709v87.266"
              fill="#E05243"
            />
          </g>
        </svg>

        <span class="ml-2">
          Erstellen
        </span>
      </template>
    </mia-button>
  </div>
</template>

<script>
import { createCloudFrontAlias, queryCloudFrontAliasStatus } from '@/api/websiteOnboarding'

export default {
  name: 'MiaDatatableCloudfrontAliasColumn',

  props: {
    row: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      hasCloudFrontAliasBeenQueried: false,
      hasCloudFrontAlias: false
    }
  },

  computed: {
    loaderName() {
      return `creating cloudfront alias for ${this.row.DomainName}`
    }
  },

  methods: {
    async queryCloudFrontAliasStatus() {
      this.$wait.start(this.loaderName)

      try {
        const hasCloudFrontAlias = await queryCloudFrontAliasStatus(this.row.DomainName)

        this.hasCloudFrontAlias = hasCloudFrontAlias
        this.hasCloudFrontAliasBeenQueried = true
      } catch (e) {
        console.log(e)

        eventBus.$emit('mia-error', {
          error: ['CloudFront Alias Status konnte nicht abgerufen werden.']
        })
      } finally {
        this.$wait.end(this.loaderName)
      }
    },

    async createCloudFrontAlias() {
      this.$wait.start(this.loaderName)

      try {
        await createCloudFrontAlias(this.row.DomainName)

        this.hasCloudFrontAlias = true
        this.hasCloudFrontAliasBeenQueried = true

        eventBus.$emit('mia-info', {
          info: ['CloudFront Alias wurde erfolgreich angelegt.']
        })
      } catch (e) {
        console.log(e)

        eventBus.$emit('mia-error', {
          error: ['CloudFront Alias konnte nicht angelegt werden.']
        })
      } finally {
        this.$wait.end(this.loaderName)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.is-loading {
  @apply cursor-wait #{!important};
}
</style>
